import React from "react";
import {
  Create,
  ImageField,
  ImageInput,
  ReferenceInput,
  SelectInput,
  SimpleForm,
  TextInput,
  required,
  NumberInput,
} from "react-admin";
import Grid from "@material-ui/core/Grid";

const ProductCreate = (props) => {
  return (
    <Create title="Create a Product" {...props}>
      <SimpleForm style={{ width: "100%" }}>
        <div style={{ width: "100%" }}>
          <Grid container spacing={2} style={{ width: "100%" }}>
            <Grid item xs={12} sm={6}>
              <ReferenceInput
                label="Brand"
                source="brandId"
                reference="brands"
                isRequired
                validate={required()}
                fullWidth
              >
                <SelectInput optionText="name" optionValue="id" />
              </ReferenceInput>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextInput
                source="name"
                isRequired
                validate={required()}
                fullWidth
              />
            </Grid>
          </Grid>
        </div>
        <div style={{ width: "100%" }}>
          <Grid container spacing={2} style={{ width: "100%" }}>
            <Grid item xs={12} sm={6}>
              <TextInput
                source="type"
                isRequired
                validate={required()}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <NumberInput
                source="amaValue"
                isRequired
                validate={required()}
                fullWidth
              />
            </Grid>
          </Grid>
        </div>
        <div style={{ width: "100%" }}>
          <TextInput
            source="details"
            isRequired
            validate={required()}
            multiline
            fullWidth
          />
        </div>
        <ImageInput source="image" label="Product Image" accept="image/*">
          <ImageField source="src" title="title" />
        </ImageInput>
      </SimpleForm>
    </Create>
  );
};

export default ProductCreate;
